import { Component, Input } from '@angular/core';
import { PFFormat, PMFormat } from '../../../../data/interfaces/circle-credit.interface';

interface HeaderCardData {
  grantorKey?: string;
  grantorName?: string;
  previousGrantor?: string;
  mediaIdentifier?: string;
  extractionDate?: string;
  grantorNote?: string;
  reportingPeriod?: string;
  version?: string;
}

@Component({
  selector: 'app-circle-credit-header-card',
  templateUrl: './circle-credit-header-card.component.html',
  styleUrls: ['./circle-credit-header-card.component.scss']
})
export class CircleCreditHeaderCardComponent {
  @Input() data: PFFormat | PMFormat | null = null;
  @Input() entityType: 'Física' | 'Moral' = 'Física';

  get headerData(): HeaderCardData | null {
    if (!this.data) return null;
    
    if (this.entityType === 'Física') {
      return (this.data as PFFormat).header;
    } else {
      // Para PM, construimos un objeto similar al header de PF
      const pmData = this.data as PMFormat;
      return {
        grantorKey: pmData.grantor,
        grantorName: pmData.grantorName,
        previousGrantor: pmData.previousGrantor,
        mediaIdentifier: pmData.institution,
        extractionDate: pmData.generationDate,
        grantorNote: pmData.format,
        reportingPeriod: pmData.reportingPeriod,
        version: pmData.version
      };
    }
  }

  get hasData(): boolean {
    const header = this.headerData;
    if (!header) return false;
    
    return !!(header.grantorKey || header.grantorName || header.mediaIdentifier);
  }

  get completionPercentage(): number {
    const header = this.headerData;
    if (!header) return 0;
    
    const baseFields = ['grantorKey', 'grantorName', 'mediaIdentifier', 'extractionDate', 'grantorNote', 'version'];
    const fields = this.entityType === 'Moral'
      ? [...baseFields, 'previousGrantor', 'reportingPeriod']
      : baseFields;
    const filledFields = fields.filter(field => header[field as keyof typeof header]);
    
    return Math.round((filledFields.length / fields.length) * 100);
  }

  get statusClass(): string {
    const percentage = this.completionPercentage;
    if (percentage === 0) return 'status-empty';
    if (percentage < 50) return 'status-incomplete';
    if (percentage < 100) return 'status-partial';
    return 'status-complete';
  }

  formatDate(date: Date | string | undefined | null): string {
    if (!date) return 'No especificado';
    try {
      const dateObj = typeof date === 'string' ? new Date(date) : date;
      if (isNaN(dateObj.getTime())) return 'Fecha inválida';
      return dateObj.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch {
      return 'Fecha inválida';
    }
  }
}
